var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"container"}},[_c('alert'),_c('header-pane'),_c('breadcrumbs'),_c('content-pane')],1),(_vm.ui.profileModal)?_c('profile-modal'):_vm._e(),(_vm.missingUserData() && _vm.accountHasAged)?_c('gdpr-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }